import { useState, useEffect, useMemo } from 'react';
import { Col, Row, Divider, Radio, Space } from 'antd';
import { Helmet } from 'react-helmet';
import MultinationalTabs from '../../../../../../components/MultinationalTabs';
import EmailTypeDriverInputs from './EmailTypeDriverInputs';
import EmailTypeAddressInputs from './EmailTypeAddressInputs';
import { useDispatch, useSelector } from 'react-redux';
import {
    getEmailDrivers,
    allEmailDrivers,
} from '../../../../../../redux/slices/settingsSlice';
import {
    oneClient,
    // updateClientDrivers,
    getClient,
    clientDataStore,
    getClientDataStore,
    createClientDataStore,
} from '../../../../../../redux/slices/clientsSlice';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { countriesOptions } from '../../../../../../shared/data/clientDetailsOptions';
import { createShallowCopy } from '../../../../../../utils/helpFunctions';
import useDataStoreState from '../hooks/useDataStoreState';

// const checkboxServicesOptions = [
//     {
//         label: 'Credit cards',
//         value: 'is_credit_cards_service',
//     },
//     {
//         label: 'Bank',
//         value: 'is_bank_service',
//     },
//     {
//         label: 'Personal protection',
//         value: 'is_personal_protection_service',
//     },
//     {
//         label: 'Leak',
//         value: 'is_leak_service',
//     },
// ];

// const checkboxSocialLinksOptions = [
//     {
//         label: 'Facebook',
//         value: 'is_show_facebook',
//     },
//     {
//         label: 'Twitter',
//         value: 'is_show_twitter',
//     },
//     {
//         label: 'Instagram',
//         value: 'is_show_instagram',
//     },
//     {
//         label: 'LinkedIn',
//         value: 'is_show_linkedin',
//     },
//     {
//         label: 'Youtube',
//         value: 'is_show_youtube',
//     },
// ];

export default function EmailTypePage() {
    const dispatch = useDispatch();
    const params = useParams();
    const emailDrivers = useSelector(allEmailDrivers);
    const client = useSelector(oneClient);
    const generalData = useSelector(clientDataStore);

    const [dataStore, setDataStore] = useDataStoreState({
        generalData,
    });

    const countriesLocalizationsData = useMemo(
        () =>
            client?.countries_localizations?.reduce((acc, el) => {
                acc[el.country_code] = el;
                return acc;
            }, {}),
        [client?.countries_localizations],
    );

    useEffect(() => {
        if (!!Object.keys(generalData).length) {
            const excludedCodes = countriesOptions
                .filter(
                    (option) =>
                        !generalData?.account_countries?.includes(option.id),
                )
                .map((item) => item.id.toLowerCase());

            setExcludedCodes(excludedCodes);
            setDataStore((prevDataStore) => ({
                ...prevDataStore,
                sms: generalData.sms || prevDataStore.sms,
                email: generalData.email || prevDataStore.email,
            }));
        }
    }, [generalData, setDataStore]);

    useEffect(() => {
        dispatch(getEmailDrivers());
    }, [dispatch]);

    const [radioButtonValue, setRadioButtonValue] = useState({
        is_has_mobile_app: null,
        is_send_account_termination: null,
    });
    // const [checkboxServicesValues, setCheckboxServicesValues] = useState([]);
    // const [checkboxSocialLinksValues, setCheckboxSocialLinksValues] = useState(
    //     [],
    // );
    const [excludedCodes, setExcludedCodes] = useState([]);
    const [data, setData] = useState({
        countries_localizations: {
            sv: {
                email_driver_id: '',
                email_driver_host: '',
                email_driver_username: '',
                email_driver_password: '',
                email_from_address: '',
                email_from_name: '',
                email_replay_to: '',
                email_support: '',
                email_info: '',
            },
            no: {
                email_driver_id: '',
                email_driver_host: '',
                email_driver_username: '',
                email_driver_password: '',
                email_from_address: '',
                email_from_name: '',
                email_replay_to: '',
                email_support: '',
                email_info: '',
            },
            fi: {
                email_driver_id: '',
                email_driver_host: '',
                email_driver_username: '',
                email_driver_password: '',
                email_from_address: '',
                email_from_name: '',
                email_replay_to: '',
                email_support: '',
                email_info: '',
            },
            da: {
                email_driver_id: '',
                email_driver_host: '',
                email_driver_username: '',
                email_driver_password: '',
                email_from_address: '',
                email_from_name: '',
                email_replay_to: '',
                email_support: '',
                email_info: '',
            },
            en: {
                email_driver_id: '',
                email_driver_host: '',
                email_driver_username: '',
                email_driver_password: '',
                email_from_address: '',
                email_from_name: '',
                email_replay_to: '',
                email_support: '',
                email_info: '',
            },
            is: {
                email_driver_id: '',
                email_driver_host: '',
                email_driver_username: '',
                email_driver_password: '',
                email_from_address: '',
                email_from_name: '',
                email_replay_to: '',
                email_support: '',
                email_info: '',
            },
            is_has_mobile_app: null,
            is_send_account_termination: null,
            is_credit_cards_service: 0,
            is_bank_service: 0,
            is_personal_protection_service: 0,
            is_leak_service: 0,
            is_show_facebook: 0,
            is_show_twitter: 0,
            is_show_instagram: 0,
            is_show_linkedin: 0,
            is_show_youtube: 0,
        },
    });

    useEffect(() => {
        setData({
            countries_localizations: {
                sv: {
                    email_driver_id:
                        countriesLocalizationsData?.sv.email_driver_id || null,
                    email_driver_host:
                        countriesLocalizationsData?.sv.email_driver_host || '',
                    email_driver_username:
                        countriesLocalizationsData?.sv.email_driver_username ||
                        '',
                    email_driver_password:
                        countriesLocalizationsData?.sv.email_driver_password ||
                        '',
                    email_from_address:
                        countriesLocalizationsData?.sv.email_from_address || '',
                    email_from_name:
                        countriesLocalizationsData?.sv.email_from_name || '',
                    email_replay_to:
                        countriesLocalizationsData?.sv.email_replay_to || '',
                    email_support:
                        countriesLocalizationsData?.sv.email_support || '',
                    email_info: countriesLocalizationsData?.sv.email_info || '',
                },
                no: {
                    email_driver_id:
                        countriesLocalizationsData?.no.email_driver_id || null,
                    email_driver_host:
                        countriesLocalizationsData?.no.email_driver_host || '',
                    email_driver_username:
                        countriesLocalizationsData?.no.email_driver_username ||
                        '',
                    email_driver_password:
                        countriesLocalizationsData?.no.email_driver_password ||
                        '',
                    email_from_address:
                        countriesLocalizationsData?.no.email_from_address || '',
                    email_from_name:
                        countriesLocalizationsData?.no.email_from_name || '',
                    email_replay_to:
                        countriesLocalizationsData?.no.email_replay_to || '',
                    email_support:
                        countriesLocalizationsData?.no.email_support || '',
                    email_info: countriesLocalizationsData?.no.email_info || '',
                },
                fi: {
                    email_driver_id:
                        countriesLocalizationsData?.fi.email_driver_id || null,
                    email_driver_host:
                        countriesLocalizationsData?.fi.email_driver_host || '',
                    email_driver_username:
                        countriesLocalizationsData?.fi.email_driver_username ||
                        '',
                    email_driver_password:
                        countriesLocalizationsData?.fi.email_driver_password ||
                        '',
                    email_from_address:
                        countriesLocalizationsData?.fi.email_from_address || '',
                    email_from_name:
                        countriesLocalizationsData?.fi.email_from_name || '',
                    email_replay_to:
                        countriesLocalizationsData?.fi.email_replay_to || '',
                    email_support:
                        countriesLocalizationsData?.fi.email_support || '',
                    email_info: countriesLocalizationsData?.fi.email_info || '',
                },
                da: {
                    email_driver_id:
                        countriesLocalizationsData?.da.email_driver_id || null,
                    email_driver_host:
                        countriesLocalizationsData?.da.email_driver_host || '',
                    email_driver_username:
                        countriesLocalizationsData?.da.email_driver_username ||
                        '',
                    email_driver_password:
                        countriesLocalizationsData?.da.email_driver_password ||
                        '',
                    email_from_address:
                        countriesLocalizationsData?.da.email_from_address || '',
                    email_from_name:
                        countriesLocalizationsData?.da.email_from_name || '',
                    email_replay_to:
                        countriesLocalizationsData?.da.email_replay_to || '',
                    email_support:
                        countriesLocalizationsData?.da.email_support || '',
                    email_info: countriesLocalizationsData?.da.email_info || '',
                },
                en: {
                    email_driver_id:
                        countriesLocalizationsData?.en.email_driver_id || null,
                    email_driver_host:
                        countriesLocalizationsData?.en.email_driver_host || '',
                    email_driver_username:
                        countriesLocalizationsData?.en.email_driver_username ||
                        '',
                    email_driver_password:
                        countriesLocalizationsData?.en.email_driver_password ||
                        '',
                    email_from_address:
                        countriesLocalizationsData?.en.email_from_address || '',
                    email_from_name:
                        countriesLocalizationsData?.en.email_from_name || '',
                    email_replay_to:
                        countriesLocalizationsData?.en.email_replay_to || '',
                    email_support:
                        countriesLocalizationsData?.en.email_support || '',
                    email_info: countriesLocalizationsData?.en.email_info || '',
                },
                is: {
                    email_driver_id:
                        countriesLocalizationsData?.is?.email_driver_id || null,
                    email_driver_host:
                        countriesLocalizationsData?.is?.email_driver_host || '',
                    email_driver_username:
                        countriesLocalizationsData?.is?.email_driver_username ||
                        '',
                    email_driver_password:
                        countriesLocalizationsData?.is?.email_driver_password ||
                        '',
                    email_from_address:
                        countriesLocalizationsData?.is?.email_from_address ||
                        '',
                    email_from_name:
                        countriesLocalizationsData?.is?.email_from_name || '',
                    email_replay_to:
                        countriesLocalizationsData?.is?.email_replay_to || '',
                    email_support:
                        countriesLocalizationsData?.is?.email_support || '',
                    email_info:
                        countriesLocalizationsData?.is?.email_info || '',
                },
            },
            is_has_mobile_app: client?.is_has_mobile_app,
            is_send_account_termination: client?.is_send_account_termination,
            is_credit_cards_service: client?.is_credit_cards_service,
            is_bank_service: client?.is_bank_service,
            is_personal_protection_service:
                client?.is_personal_protection_service,
            is_leak_service: client?.is_leak_service,
            is_show_facebook: client?.is_show_facebook,
            is_show_twitter: client?.is_show_twitter,
            is_show_instagram: client?.is_show_instagram,
            is_show_linkedin: client?.is_show_linkedin,
            is_show_youtube: client?.is_show_youtube,
        });

        // const checkboxServicesActiveOptions = createCheckboxOptionsArray(
        //     checkboxServicesOptions,
        //     client,
        // );

        // const checkboxSocialLinksActiveOptions = createCheckboxOptionsArray(
        //     checkboxSocialLinksOptions,
        //     client,
        // );

        // setCheckboxServicesValues(checkboxServicesActiveOptions);
        // setCheckboxSocialLinksValues(checkboxSocialLinksActiveOptions);
        setRadioButtonValue({
            is_has_mobile_app: client?.is_has_mobile_app,
            is_send_account_termination: client?.is_send_account_termination,
        });
    }, [countriesLocalizationsData, client]);

    const onChangeMultinational = (e, flag) => {
        const currentInput = e.target.id.slice(0, e.target.id.length - 3);
        const value = e.target.value;
        const newData = {
            ...data,
            countries_localizations: {
                ...data.countries_localizations,
                [flag]: {
                    ...data.countries_localizations[flag],
                    [currentInput]: value,
                },
            },
        };

        setData(newData);
    };

    const onChangeDataStore = (e, flag) => {
        const currentInput = e.target.id.slice(0, e.target.id.length - 3);
        const value = e.target.value;
        const dataStoreCopy = createShallowCopy(dataStore);

        dataStoreCopy.email[flag][currentInput] = value;
        setDataStore(dataStoreCopy);
    };

    const onSelectChange = (option, flag) => {
        const optionId = option.id;

        const newData = {
            ...data,
            countries_localizations: {
                ...data.countries_localizations,
                [flag]: {
                    ...data.countries_localizations[flag],
                    email_driver_id: optionId,
                    email_driver_host: '',
                    email_driver_username: '',
                    email_driver_password: '',
                },
            },
        };

        setData(newData);
    };

    const onRadioButtonsChange = (e) => {
        setRadioButtonValue({
            ...radioButtonValue,
            [e.target.name]: e.target.value,
        });
        setData({
            ...data,
            [e.target.name]: e.target.value,
        });
    };

    // const onCheckboxServicesChange = (checkedValues) => {
    //     setCheckboxServicesValues(checkedValues);

    //     const servicesKeys = checkboxServicesOptions.map((el) => el.value);
    //     const checkboxServicesActiveOptions = servicesKeys.reduce(
    //         (acc, key) => {
    //             acc[key] = checkedValues.includes(key) ? 1 : 0;
    //             return acc;
    //         },
    //         {},
    //     );

    //     setData({
    //         ...data,
    //         ...checkboxServicesActiveOptions,
    //     });
    // };

    // const onCheckboxSocialLinksChange = (checkedValues) => {
    //     setCheckboxSocialLinksValues(checkedValues);

    //     const servicesKeys = checkboxSocialLinksOptions.map((el) => el.value);
    //     const checkboxSocialLinksActiveOptions = servicesKeys.reduce(
    //         (acc, key) => {
    //             acc[key] = checkedValues.includes(key) ? 1 : 0;
    //             return acc;
    //         },
    //         {},
    //     );

    //     setData({
    //         ...data,
    //         ...checkboxSocialLinksActiveOptions,
    //     });
    // };

    const onSubmit = async (e) => {
        e.preventDefault();

        const fields = [];
        Object.keys(dataStore).forEach((key) => {
            const value = dataStore[key];
            if (value !== undefined) {
                fields.push({ key_name: key, value });
            }
        });
        const bodyDataStore = { fields };

        try {
            // await dispatch(
            //     updateClientDrivers({ id: params.id, body: data }),
            // ).unwrap();

            if (Object.keys(bodyDataStore.fields).length !== 0) {
                await dispatch(
                    createClientDataStore({
                        id: client.client_uid,
                        body: bodyDataStore,
                        collectionName: 'clients',
                    }),
                ).unwrap();
                await dispatch(
                    getClientDataStore({
                        id: client.client_uid,
                        collectionName: 'clients',
                    }),
                ).unwrap();
            }

            dispatch(getClient(params.id));
            toast.success('Changes saved successfully');
        } catch (error) {
            toast.error(error.errors);
        }
    };

    // const createCheckboxOptionsArray = (optionsObject, clientData) => {
    //     return optionsObject.reduce((acc, el) => {
    //         if (clientData?.hasOwnProperty(el.value) && clientData?.[el.value])
    //             acc.push(el.value);
    //         return acc;
    //     }, []);
    // };

    const selectOptions = emailDrivers?.reduce(
        (acc, el) => {
            acc.push({
                id: el.id,
                value: el.name.toLowerCase(),
                label: el.name,
            });
            return acc;
        },
        [
            {
                id: null,
                value: 'email_driver_id',
                label: 'Custom driver',
            },
        ],
    );

    return (
        <>
            <Helmet>
                <title>{`Console Defentry - Clients - ${client.name} - Notifications - Email`}</title>
            </Helmet>
            <Row>
                <Col span={10}>
                    <form>
                        <p className="form__input-group-header">
                            CURRENT DRIVER
                        </p>
                        <MultinationalTabs
                            codeType="countries"
                            excludedCodes={excludedCodes}
                        >
                            <EmailTypeDriverInputs
                                onChange={onChangeMultinational}
                                onSelectChange={onSelectChange}
                                data={data.countries_localizations}
                                selectOptions={selectOptions}
                            />
                        </MultinationalTabs>
                        <Divider />
                        <p className="form__input-group-header">ADDRESSES</p>
                        <MultinationalTabs
                            codeType="countries"
                            excludedCodes={excludedCodes}
                        >
                            <EmailTypeAddressInputs
                                onChange={onChangeMultinational}
                                onChangeDataStore={onChangeDataStore}
                                data={dataStore.email}
                            />
                        </MultinationalTabs>
                        <Divider />
                        <div className="form__item-wrapper--column">
                            <p className="input-label">Has mobile App</p>
                            <Radio.Group
                                onChange={onRadioButtonsChange}
                                value={radioButtonValue.is_has_mobile_app}
                                name="is_has_mobile_app"
                            >
                                <Space direction="vertical">
                                    <Radio value={1}>Yes</Radio>
                                    <Radio value={0}>No</Radio>
                                </Space>
                            </Radio.Group>
                        </div>
                        <div className="form__item-wrapper--column">
                            <p className="input-label">
                                Send account termination
                            </p>
                            <Radio.Group
                                onChange={onRadioButtonsChange}
                                value={
                                    radioButtonValue.is_send_account_termination
                                }
                                name="is_send_account_termination"
                            >
                                <Space direction="vertical">
                                    <Radio value={1}>Yes</Radio>
                                    <Radio value={0}>No</Radio>
                                </Space>
                            </Radio.Group>
                        </div>
                        {/* <Divider />
                        <div className="form__item-wrapper--column">
                            <p className="input-label">Available services</p>
                            <div className="checkbox-group-wrapper">
                                <Checkbox.Group
                                    options={checkboxServicesOptions}
                                    onChange={onCheckboxServicesChange}
                                    value={checkboxServicesValues}
                                />
                            </div>
                            <p className="input-label">Show social links</p>
                            <div className="checkbox-group-wrapper">
                                <Checkbox.Group
                                    options={checkboxSocialLinksOptions}
                                    onChange={onCheckboxSocialLinksChange}
                                    value={checkboxSocialLinksValues}
                                />
                            </div>
                        </div> */}
                        <div className="form__footer">
                            <button
                                className="modal__button modal__button-accept"
                                type="button"
                                onClick={onSubmit}
                            >
                                Save
                            </button>
                        </div>
                    </form>
                </Col>
            </Row>
        </>
    );
}
